
import { useWindowWidth } from "./useWindowWidth";

export const useSmartName = () => {
    const [_, isMobile] = useWindowWidth();

    const parseName = (name, mobileLimit = 16, desktopLimit = 32) => {
        return name.length > (isMobile ? mobileLimit : desktopLimit) ? name.substring(0, (isMobile ? mobileLimit : desktopLimit) - 2) + ".." : name;
    };

    return parseName;
};